module.exports = __webpack_public_path__ + "img/shisheido.84dee038.png";